import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';

export default new class cartComponent {
  constructor() {
    this.cartHeaderWrapper = '._cart-header-wrapper';
    this.init();
  }

  init() {
    $(document).on('click', '._shopaholic-cart-add', (e) => {
      e.preventDefault();
      const { target } = e;
      const offerId = target.getAttribute('data-offer');
      // eslint-disable-next-line unicorn/prefer-query-selector
      const name = document.getElementById(`offer-id-${offerId}`);
      name.checked = true;
      $(`#add-card-button__${offerId}`).addClass('add-cart__btn__hidden');
      $(`#go-to-basket__${offerId}`).removeClass('go-to-basket__btn__hidden');
    });

    this.addCart();
  }

  addCart() {
    const obShopaholicCartAdd = new ShopaholicCartAdd();
    obShopaholicCartAdd.setAjaxRequestCallback((obRequestData) => {
      // eslint-disable-next-line no-param-reassign
      obRequestData.update = {
        'catalog/cart/cart-header': this.cartHeaderWrapper,
      };
      // eslint-disable-next-line no-param-reassign
      obRequestData.complete = () => {
        $('._shopaholic-cart-added').show();
        this.timer = setTimeout(() => {
          $('._shopaholic-cart-added').hide();
        }, 2000);
      };
      return obRequestData;
    }).init();
  }
}();
